import { render, staticRenderFns } from "./actualizar_ivare.vue?vue&type=template&id=83c5fad4&"
import script from "./actualizar_ivare.vue?vue&type=script&lang=js&"
export * from "./actualizar_ivare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports